import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CreativeWidgetPageState} from './creativeWidgetPage.types';
import widgetAssetsReducer from './widgetAssets/widgetAssets.slice';
import {initialAssetDisplayState} from 'common/src/modules/Assets/Assets.types';
import {WidgetWithContent} from 'common/src/modules/dynamicParameters/widgets/widgets.types';

const initialState: CreativeWidgetPageState = {
  widgetAssets: initialAssetDisplayState,
  widget: null,
  loading: true,
};

const creativeWidgetPageSlice = createSlice({
  name: 'creativeWidgetPage',
  initialState,
  reducers: {
    setWidget: (state, action: PayloadAction<WidgetWithContent | null>) => {
      state.widget = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    resetState: () => initialState,
  },
});

// Custom reducer that handles widgetAssets state
const creativeWidgetPageReducer = (
  state: CreativeWidgetPageState = initialState,
  action: PayloadAction,
): CreativeWidgetPageState => {
  // Handle widgetAssets actions
  const widgetAssetsState = widgetAssetsReducer(state.widgetAssets, action);

  // Handle creativeWidgetPage slice actions
  const sliceState = creativeWidgetPageSlice.reducer(state, action);

  return {
    ...sliceState,
    widgetAssets: widgetAssetsState,
  };
};

export const {setWidget, setLoading, resetState} = creativeWidgetPageSlice.actions;

export default creativeWidgetPageReducer;
